<div class="not-found__outer-wrapper">
	<div class="not-found__inner-wrapper">
		<h1>Ошибка 404</h1>
		<p>Страница не найдена.</p>
		<p><a href="/">Перейти на главную</a></p>
	</div>
</div>
